import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#64748B",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M15.833 4.167v11.666m-9.5-.9 4.866-3.892c.444-.356.667-.534.748-.749a.83.83 0 0 0 0-.584c-.081-.215-.303-.393-.748-.75L6.333 5.067c-.693-.555-1.04-.832-1.332-.832a.83.83 0 0 0-.652.313c-.182.228-.182.672-.182 1.56v7.785c0 .888 0 1.333.182 1.56a.83.83 0 0 0 .652.314c.292 0 .639-.278 1.332-.832"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }